import type { Rng } from '../core/rng';

export function createWind(ctx: AudioContext, output: AudioNode, rng: Rng) {
  const buffer = ctx.createBuffer(1, ctx.sampleRate * 6, ctx.sampleRate),
    samples = buffer.getChannelData(0);
  let brown = 0;
  for (let i = 0; i < samples.length; i++) {
    brown = (brown + rng.range(-0.025, 0.025)) / 1.015;
    samples[i] = brown * 2;
  }
  const drift = (samples.at(-1) ?? 0) - (samples[0] ?? 0);
  for (let i = 0; i < samples.length; i++)
    samples[i] = (samples[i] ?? 0) - (drift * i) / (samples.length - 1);
  const source = ctx.createBufferSource(),
    filter = ctx.createBiquadFilter(),
    gain = ctx.createGain();
  source.buffer = buffer;
  source.loop = true;
  filter.type = 'bandpass';
  filter.frequency.value = 430;
  filter.Q.value = 0.4;
  gain.gain.value = 0.1;
  source.connect(filter).connect(gain).connect(output);
  source.start();
  return {
    gain,
    dispose() {
      source.stop();
      source.disconnect();
      filter.disconnect();
      gain.disconnect();
    },
  };
}
